import Text from "../Displays/Text";
import { useTranslation } from "react-i18next";
import PageSubTitle from "../Displays/PageSubTitle";
import { Link, Stack, useTheme } from "@mui/material";
import BrandItemThemeChanger from "../BrandIconThemeChanger/BrandIconThemeChanger";
import { useContext } from "react";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";
import { ThemeValues } from "../ThemeUsage/theme";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

interface FooterLinksProps {
  isIntroductionPage?: boolean;
}

const FooterLinks = ({ isIntroductionPage = false }: FooterLinksProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const themeName = useContext(ThemeContext);

  return (
    <Stack
      sx={{
        pt: 8,
        pb: 12,
        backgroundColor: theme.palette.background.default,
      }}
      color={theme.palette.background.default}
      alignItems="center"
    >
      <Stack
        sx={{
          width: "100%",
          px: 4,
          flexDirection: isIntroductionPage
            ? { xs: "column", sm: "row" }
            : { xs: "column" },
          justifyContent: "flex-start",
          alignItems: "flex-start",
          maxWidth: "960px",
        }}
        gap={6}
      >
        <Stack direction="row" alignItems="center" gap={2}>
          {themeName !== ThemeValues.SMA && (
            <>
              {themeName !== ThemeValues.lichtblick && (
                <Text
                  text={t("footer.poweredBy")}
                  sx={(theme) => ({
                    ml: "25px",
                    fontWeight: 700,
                    color: theme.palette.mainFont.primary,
                  })}
                />
              )}
              <BrandItemThemeChanger />
            </>
          )}
        </Stack>

        <Stack direction="column" gap={2} alignItems="flex-start">
          <Stack
            direction="row"
            flexWrap="wrap"
            gap={3}
            mb={2}
            ml="-1.5px"
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Link
              sx={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
              href="https://www.lichtblick.de/vertrag-widerrufen/"
              target="_blank"
            >
              <KeyboardReturnIcon
                titleAccess="Vertrag widerrufen"
                sx={{ color: theme.palette.mainFont.primary }}
              />
              <PageSubTitle
                color={theme.palette.mainFont.primary}
                text={t("footer.revokeContract")}
              />
            </Link>
            <Link
              sx={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
              href="https://www.lichtblick.de/vertrag-kuendigen/"
              target="_blank"
            >
              <HighlightOffIcon
                titleAccess="Vertrag kündigen"
                sx={{ color: theme.palette.mainFont.primary }}
              />
              <PageSubTitle
                color={theme.palette.mainFont.primary}
                text={t("footer.terminateContract")}
              />
            </Link>
          </Stack>

          <Stack
            direction="row"
            flexWrap="wrap"
            gap={3}
            mb={2}
            justifyContent="flex-start"
          >
            <Link
              sx={{ textDecoration: "none" }}
              href="https://www.lichtblick.de/impressum/"
              target="_blank"
            >
              <PageSubTitle
                color={theme.palette.mainFont.primary}
                text={t("footer.legalNotice")}
              />
            </Link>
            <Link
              sx={{ textDecoration: "none" }}
              href="https://www.lichtblick.de/datenschutz/"
              target="_blank"
            >
              <PageSubTitle
                color={theme.palette.mainFont.primary}
                text={t("footer.privacy")}
              />
            </Link>
            <Link
              sx={{ textDecoration: "none", fontSize: "14px" }}
              href="https://www.lichtblick.de/kontakt/"
              target="_blank"
            >
              <PageSubTitle
                color={theme.palette.mainFont.primary}
                text={t("footer.contact")}
              />
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default FooterLinks;
